import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { mgcIconDownRegular } from '@sb/mgc-icons/mgcIcon-down_regular.icon';
import { mgcIconRightRegular } from '@sb/mgc-icons/mgcIcon-right_regular.icon';
import { UserConfigService } from '@sb/shared/user-config';
import { IconButtonComponent } from '@sb/ui/button';
import { IconComponent, IconRegistry } from '@sb/ui/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-dev-tools-section',
  template: `
    <section>
      <div class="mb-2.5 flex items-center justify-between">
        <h3 class="text-xs font-semibold tracking-wide text-subtle uppercase">{{ title() }}</h3>
        <button
          sb-icon-button
          [color]="'transparentInverted'"
          [attr.aria-expanded]="!isCollapsed()"
          [attr.aria-label]="title() + ' section'"
          (click)="toggle()"
        >
          <sb-icon [name]="isCollapsed() ? 'chevron-right' : 'chevron-down'" [size]="'sm'" />
        </button>
      </div>
      @if (!isCollapsed()) {
        <ng-content />
      }
    </section>
  `,
  imports: [IconButtonComponent, IconComponent],
})
export class DevToolsSectionComponent {
  #userConfig = inject(UserConfigService);

  title = input.required<string>();
  storageKey = input.required<string>();

  #configKey = computed(() => `devToolsSection.${this.storageKey()}.collapsed`);

  isCollapsed = computed(() => this.#userConfig.get(this.#configKey(), false)());

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconDownRegular, mgcIconRightRegular]);
  }

  toggle(): void {
    this.#userConfig.set(this.#configKey(), !this.isCollapsed());
  }
}
